/* eslint-disable import/no-anonymous-default-export */
import React from "react";
import { Navigate, Outlet } from "react-router-dom";

// export default (props) => {
//   const parsedUser = JSON.parse(localStorage.getItem("jigsawUser"));
//   let user = parsedUser?.user;
//   let verified = user?.user_meta_info && user.user_meta_info?.resume;

//   return user && user.role === "candidate" ? (
//     verified ? (
//       <Outlet />
//     ) : (
//       <Navigate to="/candidate-details" />
//     )
//   ) : (
//     <Navigate to="/dashboard" />
//   );

// };

export default (props) => {
  const user = JSON.parse(localStorage.getItem("jigsawUser"));
  return user && user.user && user.user.role === "candidate" ? (
    <Outlet />
  ) : (
    <Navigate to="/dashboard/candidate" />
  );
};
